/**
 * The profile-wide item slide-out (CT-5715). The item open in it lives in the
 * URL as `?item=<kind>:<id>` — as in the prototype — so a link reopens it and
 * any tab (or the How to approach rows, CT-5714) opens one the same way.
 */
export const ITEM_PARAM = 'item';

/**
 * Every kind of item the profile can open. Each ticket registers its own
 * component (`components/item-slideout/itemSlideOutRegistry.js`):
 * trait (CT-5715), insight (CT-5716), claim_compare (CT-5718), truth (CT-5719).
 *
 * `task` and `history_event` are drawn by the prototype but not described by
 * CT-5722 / CT-5724, so they are RESERVED: a link naming one shows the
 * unavailable state until PM confirms them.
 */
export const ITEM_KINDS = Object.freeze({
  TRAIT: 'trait',
  INSIGHT: 'insight',
  CLAIM_COMPARE: 'claim_compare',
  TRUTH: 'truth',
  TASK: 'task',
  HISTORY_EVENT: 'history_event',
});

export const RESERVED_ITEM_KINDS = Object.freeze([ITEM_KINDS.TASK, ITEM_KINDS.HISTORY_EVENT]);
